import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PrimePetalLongComponent } from './prime-petal-long.component';
import { MultiCountryCurrencyModule } from 'src/app/ui/shared/pipes/multi-country-currency/multi-country-currency.module';
import { RouterModule } from '@angular/router';



@NgModule({
  declarations: [PrimePetalLongComponent],
  imports: [
    CommonModule,
    MultiCountryCurrencyModule,
    RouterModule
  ],
  exports: [
    PrimePetalLongComponent
  ]
})
export class PrimePetalLongModule { }
